export function formatLeverage(value) {
  const numeric = Number(value);
  return Number.isFinite(numeric) && numeric > 0 ? `${numeric}x` : "-";
}

export function leverageSummary(challenge) {
  if (!challenge) return "-";
  if (challenge.leverage_mode === "selectable") {
    return (challenge.allowed_leverages || []).map(formatLeverage).join("، ") || "-";
  }
  return formatLeverage(challenge.fixed_leverage ?? challenge.leverage);
}
